import App from "./app";
import { createRoot } from "./utils/createRoot";
var Root = createRoot(App);
export default Root;



//////////////////
// WEBPACK FOOTER
// ./app/shared/root.tsx
// module id = XHb/
// module chunks = 2